import api from '@/lib/axios';

import type { EffectiveNavigationResponse } from '@/types/navigation';

// ============================================
// Navigation — effective module config
// ============================================

/**
 * Fetch the effective navigation config for the current user.
 * The backend filters entries by permissions (via X-User-Permissions header
 * injected by the API gateway) and returns only visible groups/items
 * sorted by displayOrder.
 *
 * Response is Map<section, entries[]> keyed by section name
 * (e.g., "sidebar-top", "sidebar-bottom").
 *
 * @param section — optional filter (e.g., "sidebar-top"). Omit for all sections.
 */
export const getEffectiveNavigation = async (
  section?: string,
): Promise<EffectiveNavigationResponse> => {
  const response = await api.get<EffectiveNavigationResponse>(
    '/platform-service/v1/module-config/effective',
    { params: section ? { section } : undefined },
  );
  return response.data;
};
